module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAAyBAMAAADy2KUxAAAAGFBMVEVQ0sL+///p+ffG8Otz285f1sek59+N4detn88uAAAAV0lEQVQ4y2NgGAXDFzCr4JVmEgrAJ80iqIpXe6EwXmk2QQO88oZi+N0uWIBPmlVRBK/2ICEH/H5ToECagOH4nUbAY/iDhUCg4o8SAhFKIDkQSEyjYOgDALwyBtitp44JAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-arrow-right.png
// module id = 433
// module chunks = 2